import { MediaContentTypes } from "constants/contentTypes"
import { LinkTargetProperties } from "global/components/linkSettings/interfaces"
import { SiteMediaData, SiteVideoData } from "widgets/interfaces"
import { SiteMedia, SiteVideoMedia } from "../../../../siteWidgets/siteMedia"

interface HotStoriesMediaProps {
    data: SiteMediaData
    width: number
    height: number
    hideVideoAds: boolean
    isImageLinkable: boolean
    itemLinkUrl?: string
    linkTarget?: LinkTargetProperties
    articleId?: string
    onPlayStarted?: () => void
    onVideoEnded?: () => void
    onVideoError?: () => void
}

export const HotStoriesMedia = (props: HotStoriesMediaProps) => {
    const {
        data,
        width,
        height,
        hideVideoAds,
        isImageLinkable,
        itemLinkUrl,
        linkTarget,
        articleId,
        onPlayStarted,
        onVideoEnded,
        onVideoError,
    } = props
    const videoSettings = { isVideoLightbox: false, hideVideoAds }

    if (data.mediaType === MediaContentTypes.MEDIA_VIDEO) {
        return (
            <div style={{ width, height }} className="videoMediaContainer">
                <SiteVideoMedia
                    isHotStories={true}
                    data={data as SiteVideoData}
                    videoSettings={videoSettings}
                    onPlayStarted={onPlayStarted}
                    onVideoEnded={onVideoEnded}
                    onVideoError={onVideoError}
                />
            </div>
        )
    }

    return (
        <SiteMedia
            data={data}
            width={width}
            height={height}
            videoSettings={videoSettings}
            isImageLinkable={isImageLinkable}
            itemLinkUrl={itemLinkUrl}
            linkTarget={linkTarget}
            articleId={articleId}
            isHotStories={true}
        />
    )
}
